module.exports = __webpack_public_path__ + "static/index/img/baikal-200.6d0523de.jpg";